import auth from "./slice/auth";
import cart from "./slice/cart";
import config from "./slice/config";
const rootReducer = {
  auth,
  cart,
  config,
};
export default rootReducer;
